module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "CT"
  }, [_vm._v("Kinchaku Drawstring Bag")]), _vm._v(" "), _c('p', {
    staticClass: "CH-INTRO1"
  }, [_vm._v("These pretty drawstring bags are called kinchaku, a word derived from kin (width) and chaku (to wear). In Japan, they are used as kimono accessories and are popular items for decorating with sashiko.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/13967.jpg"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "MLAHD"
  }, [_vm._v("You Will Need")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-1st"
  }, [_vm._v("•  Two pieces of plain sashiko fabric 11in × 8"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (27.9cm × 21.6cm)")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1"
  }, [_vm._v("•  Two pieces of plain cotton 11in × 8"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (27.9cm × 21.5cm) for lining")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1"
  }, [_vm._v("•  Two pieces of plain cotton 3"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (8.9cm) square for flower trims")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1"
  }, [_vm._v("•  Fine sashiko thread in white and variegated perle thread No 8")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-last"
  }, [_vm._v("•  Two 25in (63.5cm) lengths of cord for drawstring")]), _vm._v(" "), _c('h5', {
    staticClass: "MLBHD"
  }, [_vm._v("Finished size:")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-1st"
  }, [_vm._v("•  10"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in × 8in (26.7cm × 20.3cm)")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/14000.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("Directions")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Marking and stitching the sashiko")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("1 Mark and cut curved bottom corners on the outside panels and the lining using a 2"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (6.4cm) diameter circle template. Mark and stitch the nowaki (grasses) sashiko pattern – see "), _c('span', {
    attrs: {
      "href": "#/c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sashiko Patterns")]), _vm._v(".")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Making the bag")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("2 Assemble the bag using "), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("in (6mm) seams throughout. With right sides together, sew one outside panel to one lining piece across the top only. Press the seam towards the outside panel. Repeat with the second panel and lining piece but this time press the seam towards the lining.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("3 With right sides together, outer against outer and lining against lining, sew the bag together ("), _c('a', {
    attrs: {
      "href": "#/c02#fig-1"
    }
  }, [_vm._v("Fig 1")]), _vm._v("). Sew to 1in (2.5cm) below the top of the bag. Leave "), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("3")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("in (1.9cm) gaps unsewn for the drawstring and a 3in (7.6cm) gap unsewn in the lining. Press seams open and clip seam allowances to "), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("8")])]), _vm._v("in (3mm) around corner curves.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/KinchakuDrawstringBag_f_fmt.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("4 Turn right side out, through the lining gap. Push the lining down inside the bag and press. Mark two lines across the bag, joining the ends of the gaps left for the drawstring, 1in (2.5cm) and 1"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("3")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("in (4.4cm) from the top edge. Stitch around the bag on each line to make a channel. Insert each drawstring, knot the ends and stitch the lining gap closed.")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Making the flower trim decorations ")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("5 Fold one 3"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (8.9cm) square of cotton in half, right sides together, and sew a "), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("in (6mm) seam to make a tube. Turn half of the tube right side out, so the fabric is doubled and seam allowance hidden. Sew running stitches around the raw end of the tube. Slip the tube over the knotted end of the drawstring and gather up tightly ("), _c('a', {
    attrs: {
      "href": "#/c02#fig-2"
    }
  }, [_vm._v("Fig 2")]), _vm._v("). Stitch through the cord and knot to finish off. Fold the tube down over the knot. Sew ‘stamens’ using yellow thread. Pinch the open end of the tube to flatten it, stitch thread through at the creases and leave loose. Pinch the end the other way and stitch another thread through. Hold all four ends of thread and knot together close to the end of the tube. Trim thread ends.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/KinchakuDrawstringBag__fmt.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6d370bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c01.vue
// module id = 63
// module chunks = 0